import AccountSwitcher from '@/lib/components/Navigation/AccountSwitcher.vue';
import AnnounceKitIcon from '@/lib/components/Shared/AnnounceKitIcon.vue';
import BrandFooter from '@/lib/components/Layout/BrandFooter.vue';
import CartIcon from '@/lib/components/Shared/CartIcon.vue';
import ContextMenu from '@/lib/components/Navigation/ContextMenu.vue';
import EditInterfaceText from '@/modules/interface-text/components/EditInterfaceText.vue';
import FeatureIntro from './lib/components/Holocron/FeatureIntro.vue';
import FeatureIntroRevealer from './lib/components/Holocron/FeatureIntroRevealer.vue';
import FileMetadata from '@/modules/entries/components/FileMetadata.vue';
import FormSelector from '@/lib/components/Selectors/FormSelector.vue';
import GrantStatusSelector from './lib/components/ListActions/GrantStatusSelector.vue';
import LinkSelector from '@/lib/components/Shared/LinkSelector.vue';
import NoPjaxButton from '@/lib/components/Shared/NoPjaxButton.vue';
import { Popover } from 'vue-bootstrap';
import ProfilePhoto from '@/lib/components/User/ProfilePhoto.vue';
import SeasonSelector from '@/lib/components/Selectors/SeasonSelector.vue';
import SimpleWidget from '@/lib/components/Shared/SimpleWidget.vue';
import StateSelector from '@/lib/components/Selectors/StateSelector.vue';
import StatusWidget from '@/lib/components/StatusWidget.vue';
import Translation from '@/modules/interface-text/components/Translation.vue';

export default {
	AccountSwitcher,
	AnnounceKitIcon,
	BrandFooter,
	CartIcon,
	ContextMenu,
	EditInterfaceText,
	FeatureIntro,
	FeatureIntroRevealer,
	FileMetadata,
	FormSelector,
	GrantStatusSelector,
	LinkSelector,
	NoPjaxButton,
	ProfilePhoto,
	SeasonSelector,
	SimpleWidget,
	StateSelector,
	StatusWidget,
	Translation,
	Popover,
};
